import Control from "./Control.js"

export default class PiP extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-pip", true)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get available() {
    const mediaElement = this.player.mediaElement
    if (mediaElement == null || typeof mediaElement.webkitSupportsPresentationMode != "function" || typeof mediaElement.webkitSetPresentationMode != "function")
      return false
    else
      return mediaElement.webkitSupportsPresentationMode("picture-in-picture")
  }

  onplaying(event) {
    this.forceUpdate()
  }

  onClick(event) {
    const mediaElement = this.player.mediaElement
    mediaElement.webkitSetPresentationMode(mediaElement.webkitPresentationMode === "picture-in-picture" ? "inline" : "picture-in-picture");
  }

  render() {
    if (!this.available)
      return null

    return super.render()
  }
}
